const ExpiviMasks = [
    {
        "selector": "LShoe*",
        "pattern": "M 1235.3 364.5 H 3435.4 V 5208.4 H 1235.3 Z"
    },
    {
        "selector": "RShoe*",
        "pattern": "M 5087.1 364.5 H 7287.2 V 5208.4 H 5087.1 Z"
    }
];

const ExpiviOrigins = {
    "left": {
        "x": 784.886,
        "y": 601.4395
    },
    "right": {
        "x": 1946.427,
        "y": 601.4395
    }
};

const ExpiviTransformations = {
    'm4': 0.85,
    'w5': 0.85,

    'm5': 0.88,
    'w6': 0.88,

    'm6': 0.91,
    'w7': 0.91,

    'm7': 0.94,
    'w8': 0.94,

    'm8': 0.97,
    'w9': 0.97,

    'm9': 1.0,
    'w10': 1.0,

    'm10': 1.03,
    'w11': 1.03,

    'm11': 1.06,
    'w12': 1.06,

    'm12': 1.09,
    'w13': 1.09,

    'm13': 1.12,
    'w14': 1.12,
};
